import CustomNotificationEvent from "@casino/client/events/CustomNotificationEvent";
import useTranslation from "@casino/legacy/client/hooks/i18n/useTranslation";

const useRedirectToLogin = () => {
  const waitRedirect = useTranslation("login.wait_redirect");

  const showRedirectToLoginNotification = async () => {
    CustomNotificationEvent.create({
      type: "normal",
      data: {
        body: waitRedirect,
      },
      priority: "normal",
    });
  };

  return { showRedirectToLoginNotification };
};

export default useRedirectToLogin;
